var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temItens
    ? _c(
        "div",
        _vm._b(
          { staticClass: "servicos-citados ia-block-card" },
          "div",
          _vm.MOLDURA_DO_THREAD,
          false
        ),
        [
          _c(
            "button",
            {
              staticClass:
                "ia-block-card__cabecalho ia-block-card__cabecalho--fita ia-block-card__cabecalho--clicavel",
              attrs: { type: "button", "aria-expanded": String(_vm.aberto) },
              on: { click: _vm.alternar }
            },
            [
              _c("icon-svg", {
                staticClass: "ia-block-card__icone",
                attrs: { name: "book", size: 14, color: "var(--primary)" }
              }),
              _c("span", { staticClass: "ia-block-card__titulo" }, [
                _vm._v(_vm._s(_vm.titulo))
              ]),
              _c("span", { staticClass: "ia-block-card__meta" }, [
                _vm._v(_vm._s(_vm.resumo))
              ]),
              _c("icon-svg", {
                staticClass: "ia-block-seta",
                class: _vm.classeSeta,
                attrs: {
                  name: "arrow-down-new-ux",
                  size: 14,
                  color: "var(--neutral-700)"
                }
              })
            ],
            1
          ),
          _vm._l(_vm.itensDecorados, function(item) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.aberto,
                    expression: "aberto"
                  }
                ],
                key: item.chave,
                staticClass: "servico-citado-item"
              },
              [
                _c(
                  "span",
                  { staticClass: "servico-citado-ordem ia-texto-selo" },
                  [_vm._v(_vm._s(item.ordem))]
                ),
                _c("div", { staticClass: "servico-citado-corpo" }, [
                  _c(
                    "div",
                    { staticClass: "servico-citado-topo" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "servico-citado-nome ia-texto-auxiliar"
                        },
                        [_vm._v(_vm._s(item.nome_canonico))]
                      ),
                      _c("BaseStatus", {
                        attrs: {
                          soft: "",
                          "preserve-case": "",
                          content: item.rotuloTexto,
                          color: item.rotuloCor
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "servico-citado-motivo ia-texto-auxiliar" },
                    [_vm._v(_vm._s(item.motivo))]
                  ),
                  item.aviso
                    ? _c(
                        "div",
                        {
                          staticClass: "servico-citado-motivo ia-texto-auxiliar"
                        },
                        [_c("output", [_vm._v(_vm._s(item.aviso))])]
                      )
                    : _vm._e(),
                  item.erro
                    ? _c(
                        "div",
                        {
                          staticClass: "servico-citado-erro ia-texto-auxiliar",
                          attrs: { role: "alert" }
                        },
                        [_vm._v(" " + _vm._s(item.erro) + " ")]
                      )
                    : _vm._e()
                ]),
                _c("div", { staticClass: "servico-citado-acoes" }, [
                  item.mostraRascunho
                    ? _c(
                        "button",
                        {
                          staticClass: "servico-citado-acao",
                          attrs: {
                            type: "button",
                            "data-test": "baixar-rascunho",
                            disabled: item.baixando || item.bloqueado,
                            "aria-label": item.rascunhoAcao
                          },
                          on: {
                            click: function($event) {
                              return _vm.baixarRascunho(item)
                            }
                          }
                        },
                        [
                          _c("icon-svg", {
                            class: item.baixando ? "ia-shimmer-text" : "",
                            attrs: {
                              name: "document-download",
                              size: 14,
                              color: "var(--neutral-700)"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      staticClass: "servico-citado-acao",
                      attrs: {
                        type: "button",
                        "data-test": "abrir-servico",
                        "aria-label": item.rotuloAcao
                      },
                      on: {
                        click: function($event) {
                          return _vm.abrirServico(item)
                        }
                      }
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "go-out",
                          size: 14,
                          color: "var(--neutral-700)"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }